/* eslint-disable */
import { every, find, findIndex, startCase } from 'lodash'
import PropTypes from 'prop-types'
import { Component } from 'react'
import { connect } from 'react-redux'
import { track } from 'lib/analytics'
import { getExperimentGroupName } from 'lib/isInExperiment'

import { Modal, ModalBody, ModalHeader } from 'components/modal'
import * as consts from 'registry/constants'
import { GOAL_STATES, GOALS } from 'registry/constants'
import { saveRegistry, setActiveModal } from 'registry/actions'
import {
  getActiveModal,
  getActiveModalProps,
  getArrivalDate,
  getArrivalKnown,
  getCashFunds,
  getCatalogCategoriesConfig,
  getCurrentShower,
  getDevicePlatform,
  getIsFetchingCashFundsConfig,
  getIsFetchingCatalogCategoriesConfig,
  getIsMobile,
  getReceivingHelloBabyBox,
  getRegistryId,
  getRegistrySetupGoal,
  getRegistrySetupProgress,
  getRegistryTitle,
  getRegistryUIState,
  getRegistryUrlSlug,
  getRegItemsCount,
  getSearchLevel,
  getShowerInfo,
} from 'registry/reducers'

import RegistryVisibilityForm from 'registry/forms/registry-visibility-form'
import InternationalUserForm from 'registry/forms/international-user-form'
import { CONFIG, DEVICE_PLATFORMS } from 'shared/constants'
import { AppPromoAddItemModal } from 'shared/app-modal-wave'
import { mobileAppDownloadPath } from 'lib/urls'

import { ProductOffersBody } from 'registry/components/product-offers-modal'
import AddressSuggestionForm from 'registry/settings-page/shipping-address/address-suggestion-form'
import ConfirmAddressForm from 'registry/settings-page/shipping-address/confirm-address-form'
import AddBabylistButtonForm from './add-babylist-button-form'
import InstallBabylistExtension from './install-babylist-extension'
import AddShippingAddressWizard from './AddShippingAddressWizard'
import ArrivalDateForm from './arrival-date-form'
import AddFromBabylistStore from './add-from-babylist-store'
import AddCashFund from './add-cash-fund'
import FamilyDetailsForm from './family-details-form'
import HelloBabyBoxStatus from './hello-baby-box-status'
import InsertCardOrders from './insert-card-orders'
import PersonalizeRegistryForm from './personalize-registry'
import PurchaseFromBabylistStore from './purchase-from-babylist-store'
import RegistryDiscountStatus from './registry-discount-status'
import ShowerInfoForm from './shower-info-form'
import {
  AddAnyStoreIcon,
  BabylistStoreIcon,
  CashFundIcon,
  DiscountStatusIcon,
  InsertCardIcon,
  LinkRegistyIcon,
  PartnerIcon,
  PersonalizeIcon,
  PresentIcon,
  ShippingIcon,
  ShoppingBagIcon,
  ShowerIcon,
  StrollerIcon,
} from '../../components/icons'
import { fetchCashFundsConfig, fetchCatalogCategoriesConfig } from '../actions'
import withCurrentUser from 'shared/HOC/withCurrentUser'

class ModalManager extends Component {
  static propTypes = {
    activeModal: PropTypes.string,
    cashFunds: PropTypes.arrayOf(PropTypes.object).isRequired,
    currentUser: PropTypes.object,
    devicePlatform: PropTypes.oneOf(Object.values(DEVICE_PLATFORMS)),
    helloBabyBoxGoal: PropTypes.object,
    onSaveSeenHelloBabyBoxQualified: PropTypes.func.isRequired,
    receivingHelloBabyBox: PropTypes.bool,
    setActiveModal: PropTypes.func.isRequired,
    setupGoals: PropTypes.array,
    title: PropTypes.string,
    uiState: PropTypes.shape({
      hasSeenHelloBabyBoxQualified: PropTypes.bool,
    }),
  }

  appDownloadTrackingAttributes = () => {
    const { currentUser } = this.props
    const experiments =
      typeof currentUser === 'undefined' ? [] : currentUser?.experiments
    const experimentGroup = getExperimentGroupName(
      experiments,
      'ex2d_mweb_interstitial'
    )

    return {
      eventLocation: track.EventLocation.TILE_MINUS_APP_DOWNLOAD,
      experimentName: experimentGroup ? 'ex2d_mweb_interstitial' : null,
      experimentGroup,
    }
  }

  render() {
    const {
      activeModal,
      activeModalProps,
      cashFunds,
      devicePlatform,
      helloBabyBoxGoal,
      onSaveSeenHelloBabyBoxQualified,
      receivingHelloBabyBox,
      setActiveModal,
      isMobile,
      uiState: { hasSeenHelloBabyBoxQualified },
    } = this.props
    let content
    let headerContent = null
    const modalProps = {
      onHide: () => setActiveModal(null), // const func = () => () => val
      show: !!activeModal,
      title: startCase(activeModal),
      ...activeModalProps,
    }

    // true if we're navigating modals from the HBB goals modal
    const isOpeningFromHBBGoalsModal =
      activeModalProps?.from === consts.HELLO_BABY_BOX

    if (isOpeningFromHBBGoalsModal) {
      // "Navigate back" to the HBB modal instead of just closing the modal
      modalProps.onHide = () => setActiveModal(consts.HELLO_BABY_BOX)
    }

    switch (activeModal) {
      case consts.ADD_ARRIVAL_DATE:
        content = (
          <ArrivalDateForm
            isOpeningFromHBBGoalsModal={isOpeningFromHBBGoalsModal}
          />
        )
        modalProps.icon = <StrollerIcon alternate />
        modalProps.title = consts.ADD_ARRIVAL_DATE
        modalProps.affixedFooter = false
        break
      case consts.ADD_FAMILY_DETAILS:
        content = <FamilyDetailsForm />
        modalProps.title = consts.ADD_FAMILY_DETAILS
        modalProps.icon = <PartnerIcon alternate />
        modalProps.affixedFooter = true
        break
      case consts.ADD_BABYLIST_BUTTON:
        const { storeName, storeUrl } = activeModalProps
        content = (
          <AddBabylistButtonForm
            isOpeningFromHBBGoalsModal={isOpeningFromHBBGoalsModal}
            storeName={storeName}
            storeUrl={storeUrl}
          />
        )
        modalProps.title = 'Add items from any store'
        modalProps.icon = <AddAnyStoreIcon alternate />
        break
      case consts.INSTALL_BABYLIST_EXTENSION:
        content = (
          <InstallBabylistExtension
            storeName={activeModalProps.storeName}
            storeUrl={activeModalProps.storeUrl}
            onHide={modalProps.onHide}
          />
        )
        // Title is handled in InstallBabylistExtension to give custom paddings for the modal
        modalProps.title = null
        break
      case consts.ADD_CASH_FUND:
        content = <AddCashFund cashFunds={cashFunds} />
        modalProps.icon = <CashFundIcon alternate />
        break
      case consts.ADD_SHIPPING_ADDRESS:
        content = (
          <AddShippingAddressWizard
            isOpeningFromHBBGoalsModal={isOpeningFromHBBGoalsModal}
          />
        )
        modalProps.title = consts.ADD_SHIPPING_ADDRESS
        modalProps.icon = <ShippingIcon />
        modalProps.closeButton = false
        break
      case consts.ADD_SHOWER_INFO:
        content = <ShowerInfoForm />
        modalProps.title = 'Shower, sprinkle, or just a list?'
        modalProps.icon = <ShowerIcon />
        modalProps.affixedFooter = false
        break
      case consts.ADD_FROM_BABYLIST_STORE:
        content = (
          <AddFromBabylistStore categories={this.props.catalogCategories} />
        )
        modalProps.icon = <BabylistStoreIcon />
        break
      case consts.CONFIRM_SHIPPING_ADDRESS:
        content = (
          <ConfirmAddressForm
            enteredAddress={modalProps.enteredAddress}
            fieldErrors={modalProps.fieldErrors}
            onEdit={modalProps.onEdit}
          />
        )
        modalProps.title = 'Check your address'
        modalProps.closeButton = false
        break
      case consts.INSTALL_BABYLIST_APP:
        // FOR EXPERIMENT: short cirtuit switch so we can
        // render custom Modal. If control wins or we modify new
        // experience to use existing Modal framework we can go back
        // to setting `content` and modifying `modalProps`.
        return (
          <AppPromoAddItemModal
            trackAttributes={this.appDownloadTrackingAttributes()}
            isVisible={!!activeModal}
            hideModal={modalProps.onHide}
            downloadPath={mobileAppDownloadPath()}
          />
        )
      case consts.INTERNATIONAL_USER:
        // override - no title for this one
        modalProps.title = ''
        content = <InternationalUserForm />
        break
      case consts.HELLO_BABY_BOX:
        content = <HelloBabyBoxStatus />
        modalProps.icon = <PresentIcon />
        const isHelloBabyBoxQualified =
          helloBabyBoxGoal.state === GOAL_STATES.COMPLETE
        if (receivingHelloBabyBox) {
          modalProps.title = `You're getting a Hello Baby Box!`
        } else if (isHelloBabyBoxQualified) {
          modalProps.title = 'Hello, Hello Baby Box!'
        } else {
          modalProps.title = 'How do I get a Hello Baby Box?'
        }
        modalProps.onHide = () => {
          setActiveModal(null)
          const helloBabyBoxGoalIndex = findIndex(
            this.props.setupGoals,
            ({ id }) => id === GOALS.helloBabyBox
          )
          const goalsBeforeHelloBabyBox = this.props.setupGoals.slice(
            0,
            helloBabyBoxGoalIndex
          )
          const areGoalsBeforeHelloBabyBoxAllCompleted = every(
            goalsBeforeHelloBabyBox,
            ({ state }) => state === GOAL_STATES.COMPLETE
          )
          // when dismissing HBB modal for first time, set seenHBBQualified only if HBB is qualified OR if every goals prior to HBB are complete
          if (
            !hasSeenHelloBabyBoxQualified &&
            (areGoalsBeforeHelloBabyBoxAllCompleted || isHelloBabyBoxQualified)
          ) {
            onSaveSeenHelloBabyBoxQualified()
          }
        }
        break
      case consts.ORDER_INSERT_CARDS:
        content = <InsertCardOrders />
        modalProps.icon = <InsertCardIcon alternate={true} />
        break
      case consts.PRIVACY_SETTINGS:
        content = <RegistryVisibilityForm layout="modal" />
        break
      case consts.PRODUCT_OFFERS:
        content = (
          <ProductOffersBody
            brand={modalProps.brand}
            imageUrl={modalProps.imageUrl}
            name={modalProps.name}
            offers={modalProps.offers}
            productId={modalProps.productId}
            regItemId={modalProps.regItemId}
            dismissModal={() => setActiveModal(null)}
            isMobile={isMobile}
            openRedirectModal={modalProps.openRedirectModal}
          />
        )
        break
      case consts.PERSONALIZE_YOUR_REGISTRY:
        content = <PersonalizeRegistryForm />
        modalProps.title = 'Add a photo and a greeting'
        modalProps.icon = <PersonalizeIcon />
        modalProps.affixedFooter = true
        break
      case consts.PURCHASE_FROM_BABYLIST_STORE:
        content = <PurchaseFromBabylistStore />
        modalProps.title = 'Receive gifts from the Babylist Shop'
        modalProps.icon = <ShoppingBagIcon />
        break
      case consts.RECOMMEND_SHIPPING_ADDRESS:
        content = (
          <AddressSuggestionForm
            recommendedAddress={modalProps.recommendedAddress}
            enteredAddress={modalProps.enteredAddress}
            fieldErrors={modalProps.fieldErrors}
            onEdit={modalProps.onEdit}
          />
        )
        modalProps.title = 'Select an address'
        modalProps.closeButton = false
        break
      case consts.REGISTRY_DISCOUNT:
        content = <RegistryDiscountStatus />
        modalProps.icon = <DiscountStatusIcon />
        const discountGoal = find(
          this.props.setupGoals,
          (goal) => goal.id === GOALS.registryDiscount
        )
        if (discountGoal.state === GOAL_STATES.COMPLETE) {
          modalProps.title = `Congrats! You've qualified!`
        } else {
          modalProps.title = `Get ${CONFIG.store.registryDiscountPctDisplay} off items in the Babylist shop!`
        }
        break
      default:
        return null // Don't interfere with other components using ActiveModal
    }

    return (
      <Modal {...modalProps}>
        {headerContent}
        <ModalBody>{content}</ModalBody>
      </Modal>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    arrivalDate: getArrivalDate(state),
    activeModal: getActiveModal(state),
    activeModalProps: getActiveModalProps(state),
    registryId: getRegistryId(state),
    setupGoals: getRegistrySetupProgress(state).goals,
    helloBabyBoxGoal: getRegistrySetupGoal(state, GOALS.helloBabyBox),
    title: getRegistryTitle(state),
    uiState: getRegistryUIState(state),
    currentShower: getCurrentShower(state),
    regItemsCount: getRegItemsCount(state),
    havingShower: getShowerInfo(state).havingShower,
    isEligibleForRegistryDiscount: state.registry.isEligibleForRegistryDiscount,
    knownArrivalDate: getArrivalKnown(state),
    receivingHelloBabyBox: getReceivingHelloBabyBox(state),
    registryUrlSlug: getRegistryUrlSlug(state),
    searchLevel: getSearchLevel(state),
    devicePlatform: getDevicePlatform(state),
    cashFunds: getCashFunds(state),
    catalogCategories: getCatalogCategoriesConfig(state),
    isFetchingCashFundsConfig: getIsFetchingCashFundsConfig(state),
    isFetchingCatalogCategoriesConfig:
      getIsFetchingCatalogCategoriesConfig(state),
    isMobile: getIsMobile(state),
  }
}

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const updateUIState = (nextUIState) =>
    dispatchProps.saveRegistry({
      registry: {
        id: stateProps.registryId,
        uiState: {
          ...stateProps.uiState,
          ...nextUIState,
        },
      },
    })
  return {
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    onSaveSeenHelloBabyBoxQualified: () =>
      updateUIState({
        hasSeenHelloBabyBoxQualified: true,
      }),
  }
}

class ModalManagerDataFetcher extends Component {
  componentDidMount() {
    if (!this.props.isFetchingCashFundsConfig) {
      this.props.fetchCashFundsConfig()
    }

    if (!this.props.isFetchingCatalogCategoriesConfig) {
      this.props.fetchCatalogCategoriesConfig()
    }
  }

  render() {
    return <ModalManager {...this.props} />
  }
}

export default connect(
  mapStateToProps,
  {
    saveRegistry,
    setActiveModal,
    fetchCashFundsConfig,
    fetchCatalogCategoriesConfig,
  },
  mergeProps
)(withCurrentUser(ModalManagerDataFetcher))
